import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdSubscriptions = z.any()
export type TagsGetMunicipalities_municipalityIdSubscriptions = z.infer<typeof tagsGetMunicipalities_municipalityIdSubscriptions>

export const paramsGetMunicipalities_municipalityIdSubscriptions = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdSubscriptions = z.infer<typeof paramsGetMunicipalities_municipalityIdSubscriptions>

export const responseGetMunicipalities_municipalityIdSubscriptions = z.object({ "payload": z.array(z.object({ "id": z.string().uuid(), "package": z.string(), "price": z.number(), "vat": z.number(), "createdAt": z.string(), "updatedAt": z.string(), "validFrom": z.string(), "validUntil": z.string().optional(), "paidAt": z.string().optional(), "cancelledAt": z.string().optional(), "userId": z.string().uuid(), "municipalityId": z.string().uuid(), "payments": z.array(z.object({ "id": z.string().uuid(), "refId": z.string(), "transId": z.string(), "status": z.string(), "createdAt": z.string(), "paidAt": z.string().optional(), "cancelledAt": z.string().optional() })) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdSubscriptions = z.infer<typeof responseGetMunicipalities_municipalityIdSubscriptions>

interface IGetMunicipalities_municipalityIdSubscriptions extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdSubscriptions,
  params: ParamsGetMunicipalities_municipalityIdSubscriptions,
  response: ResponseGetMunicipalities_municipalityIdSubscriptions
}
export const URL = '/municipalities/:municipalityId/subscriptions'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdSubscriptions,
    params: paramsGetMunicipalities_municipalityIdSubscriptions,
    response: responseGetMunicipalities_municipalityIdSubscriptions
  }
}
export interface Municipalities_municipalityIdSubscriptions extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdSubscriptions
}